import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Layout, Rate, Progress, Image } from "antd";
import { useNavigate } from "react-router";
import { REVIEWS, UPLOADS_URL } from "../../config/constants/api";
import { Get } from "../../config/api/get";
import { FaArrowRight, FaArrowLeft } from "react-icons/fa";
import dayjs from "dayjs";
import ReactPaginate from "react-paginate";
import { ImageUrl } from "../../helpers/Functions";
import "../profile/profile.css";
import "./review.css";

const navItems = [
  { label: "Profile", path: "/profile" },
  { label: "Education", path: "/education" },
  { label: "Meetings", path: "/meetings" },
  { label: "Subjects", path: "/subjects" },
  { label: "Services", path: "/services" },
  { label: "Hourly Rates", path: "/rates" },
  { label: "Rating & Review", path: "/review" },
  { label: "My Meetings", path: "/my-meetings" },
  { label: "My Assesments", path: "/my-assesments" },
];

const starRows = [5, 4, 3, 2, 1];

function Review() {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.userData);
  const token = useSelector((state) => state.user.userToken);
  const [, setLoading] = useState(false);
  const [reviews, setReviews] = useState([]);
  const [ratings, setRatings] = useState({});
  const [paginationConfig, setPaginationConfig] = useState({
    pageNumber: 1,
    limit: 10,
    totalDocs: 0,
    totalPages: 0,
  });

  useEffect(() => {
    if (!token) {
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  useEffect(() => {
    getReviews();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handlePageChange = (e) => {
    setPaginationConfig({
      ...paginationConfig,
      pageNumber: Number(e.selected) + 1,
    });

    getReviews(Number(e.selected) + 1);
  };

  const getReviews = async (pageNumber) => {
    setLoading(true);
    try {
      const response = await Get(REVIEWS.getAll + user._id, token, {
        page: pageNumber
          ? pageNumber.toString()
          : paginationConfig.pageNumber.toString(),
        limit: "5",
      });
      setLoading(false);
      console.log("response", response);
      if (response?.status) {
        setReviews(response?.data?.reviews);
        setRatings(response.data.ratings);
        setPaginationConfig({
          pageNumber: response?.data?.page,
          limit: response?.data?.limit,
          totalDocs: response?.data?.totalReviews,
          totalPages: response?.data?.totalPages,
        });
      } else {
        console.log("error====>", response);
      }
    } catch (error) {
      console.log(error.message);
      setLoading(false);
    }
  };

  return (
    <Layout className="profile-page">
      <section className="profile-hero">
        <div className="profile-wrap profile-hero-inner">
          <button
            type="button"
            className="review-back"
            onClick={() => navigate(-1)}
            aria-label="Go back"
          >
            <FaArrowLeft />
            Back
          </button>
          <h1 className="fontFamily1 profile-hero-title">Rating & Review</h1>
          <p className="fontFamily1 profile-hero-sub">
            See how students rate your sessions and read their feedback.
          </p>
        </div>
      </section>

      <div className="profile-wrap profile-main">
        <div className="profile-layout">
          <aside className="profile-nav">
            <p className="profile-nav-title">Account</p>
            <ul className="profile-nav-list">
              {navItems.map((item) => (
                <li key={item.path}>
                  <button
                    type="button"
                    className={`profile-nav-item${
                      item.path === "/review" ? " is-active" : ""
                    }`}
                    onClick={() => navigate(item.path)}
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </aside>

          <section className="profile-panel">
            <div className="profile-panel-head">
              <div>
                <h2 className="fontFamily1 profile-panel-title">
                  Rating Summary
                </h2>
                <p className="profile-panel-sub">
                  Breakdown of ratings received from students.
                </p>
              </div>
            </div>

            <div className="review-rating-list">
              {starRows.map((star) => (
                <div key={star} className="review-rating-row">
                  <span className="review-rating-label">{star} Star</span>
                  <Rate
                    disabled
                    allowHalf
                    value={star}
                    style={{ color: "#FABF35", fontSize: 14 }}
                  />
                  <div className="review-rating-progress">
                    <Progress
                      strokeLinecap="butt"
                      percent={ratings[star] || 0}
                      strokeColor={{ from: "#FABF35", to: "#FABF35" }}
                      style={{ width: "100%", color: "#FABF35" }}
                    />
                  </div>
                </div>
              ))}
            </div>

            <div className="review-list-head">
              <h2 className="fontFamily1 profile-panel-title">Student Reviews</h2>
              <p className="profile-panel-sub">
                Latest feedback from your students.
              </p>
            </div>

            {reviews.length === 0 ? (
              <div className="review-empty">
                <p>No Reviews Yet</p>
              </div>
            ) : (
              <div className="review-cards">
                {reviews.map((item, index) => (
                  <article
                    key={item?._id || index}
                    className="review-card"
                  >
                    <Image
                      preview={false}
                      src={
                        !item?.student?.image
                          ? ImageUrl("avatar.png")
                          : UPLOADS_URL + "/" + item.student.image
                      }
                      height={72}
                      width={72}
                      className="review-card-avatar"
                    />
                    <div className="review-card-body">
                      <h3 className="review-card-name">
                        {(item?.student?.firstName || "") +
                          " " +
                          (item?.student?.lastName || "")}
                      </h3>
                      <div className="review-card-meta">
                        <span>{item?.rating || 1} Stars</span>
                        <Rate
                          disabled
                          value={item?.rating || 1}
                          style={{ fontSize: 12, color: "#FABF35" }}
                        />
                        <span>
                          {dayjs(item?.createdAt).format("DD MMMM, YYYY")}
                        </span>
                      </div>
                      <p className="review-card-comment">{item?.comment}</p>
                    </div>
                  </article>
                ))}
              </div>
            )}

            <div className="review-pagination">
              <ReactPaginate
                breakLabel="..."
                nextLabel={<FaArrowRight style={{ color: "grey" }} />}
                pageRangeDisplayed={window.innerWidth > 500 ? 4 : 1}
                marginPagesDisplayed={window.innerWidth > 500 ? 4 : 1}
                onPageChange={handlePageChange}
                pageCount={paginationConfig?.totalPages}
                forcePage={paginationConfig?.pageNumber - 1}
                previousLabel={<FaArrowLeft style={{ color: "grey" }} />}
                renderOnZeroPageCount={null}
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                breakClassName="page-item"
                breakLinkClassName="page-link"
                containerClassName="paginationContainer"
                activeClassName="active"
              />
            </div>
          </section>
        </div>
      </div>
    </Layout>
  );
}

export default Review;
